import React from 'react';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Switch } from '../../../components/ui/switch';
import { Textarea } from '../../../components/ui/textarea';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '../../../components/ui/dialog';

export const CreateClientTypeDialog = ({ open, onOpenChange, newType, setNewType, onCreate }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-md">
      <DialogHeader>
        <DialogTitle>Create Client Type</DialogTitle>
        <DialogDescription>Define a new pricing tier for your wholesale clients</DialogDescription>
      </DialogHeader>

      <div className="space-y-4 py-4">
        <div className="space-y-2">
          <Label htmlFor="name">Name</Label>
          <Input
            id="name"
            value={newType.name}
            onChange={(e) => setNewType({ ...newType, name: e.target.value })}
            placeholder="e.g., Premium Partner"
            data-testid="create-client-type-name"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="description">Description</Label>
          <Textarea
            id="description"
            value={newType.description}
            onChange={(e) => setNewType({ ...newType, description: e.target.value })}
            placeholder="Describe this client type..."
            rows={2}
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="discount">Default Discount (%)</Label>
          <Input
            id="discount"
            type="number"
            min="0"
            max="100"
            value={newType.default_discount_percent}
            onChange={(e) => setNewType({ ...newType, default_discount_percent: parseFloat(e.target.value) || 0 })}
          />
        </div>

        <div className="flex items-center justify-between">
          <div>
            <Label htmlFor="guaranteed">Guaranteed Returns</Label>
            <p className="text-xs text-gray-500">Allow invoice adjustments</p>
          </div>
          <Switch
            id="guaranteed"
            checked={newType.has_guaranteed_returns}
            onCheckedChange={(checked) => setNewType({ ...newType, has_guaranteed_returns: checked })}
          />
        </div>

        {newType.has_guaranteed_returns && (
          <div className="space-y-2">
            <Label htmlFor="window">Adjustment Window (business days)</Label>
            <Input
              id="window"
              type="number"
              min="1"
              max="30"
              value={newType.adjustment_window_days}
              onChange={(e) => setNewType({ ...newType, adjustment_window_days: parseInt(e.target.value) || 7 })}
            />
          </div>
        )}
      </div>

      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
        <Button
          onClick={onCreate}
          disabled={!newType.name}
          className="bg-amber-500 hover:bg-amber-600"
          data-testid="confirm-create-client-type-btn"
        >
          Create Client Type
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
